"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionChooser = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const react_1 = __importStar(require("react"));
const DataChooser_1 = __importDefault(require("../DataChooser"));
const makeDataChooser_1 = __importDefault(require("../helpers/makeDataChooser"));
exports.PositionChooser = (0, makeDataChooser_1.default)((props) => {
    const { value, canCreate } = props, otherProps = __rest(props, ["value", "canCreate"]);
    const self = (0, useSelf_1.default)();
    const { goTo } = (0, useNav_1.default)();
    const canManageAllPositions = self.isPrimary || self.accessiblePlaces.all;
    const valueWithType = value === null || value === void 0 ? void 0 : value.map(p => (Object.assign(Object.assign({}, p), { type: DataType_1.default.POSITION })));
    const handleAddPosition = (0, react_1.useCallback)((name) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise(resolve => goTo(lib_pages_1.default.POSITIONS_CREATE, undefined, {
            name,
            onCreate: resolve,
        }));
    }), [goTo]);
    return (react_1.default.createElement(DataChooser_1.default, Object.assign({}, otherProps, { value: valueWithType, type: [DataType_1.default.POSITION], onAddNew: canCreate && canManageAllPositions ? handleAddPosition : undefined })));
});
exports.default = exports.PositionChooser;
